import axiosInstance from '@/utils/api.js'

function validation (payload) {
  payload.group_id = parseInt(payload.group_id, 10)
  payload.id = parseInt(payload.id, 10)
  payload.is_enabled = parseInt(payload.is_enabled, 10)
  payload.priority = parseInt(payload.priority, 10)
}

var state = {
  transferFunds: []
}

var getters = {
  TRANSFER_FUNDS_SETTINGS: (state) => {
    return state.transferFunds
  }
}

var mutations = {
  SET_TRANSFER_FUNDS_SETTINGS: (state, payload) => {
    state.transferFunds = payload
  }
}

var actions = {
  GET_TRANSFER_FUNDS_SETTINGS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/funds_flow_settings')
    if (result.status === 200) {
      context.commit('SET_TRANSFER_FUNDS_SETTINGS', result.data)
    }
  },
  CREATE_TRANSFER_FUNDS_SETTINGS: (context, payload) => {
    validation(payload)
    return axiosInstance.post('/settings/funds_flow_settings', payload)
  },
  UPDATE_TRANSFER_FUNDS_SETTINGS: (context, payload) => {
    validation(payload)
    return axiosInstance.put('/settings/funds_flow_settings', payload)
  },
  DELETE_TRANSFER_FUNDS_SETTINGS: (context, payload) => {
    return axiosInstance.delete('/settings/funds_flow_settings?funds_flow_settings_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/transferFunds.js